export default __webpack_public_path__ + "static/media/go-to-icon.f064163d.svg";